import { Box, Divider, Grid, styled, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { CurrencyJSON, handleUndefined, PriceType } from "../../../../common/const";
import { useState } from "react";
import ItemInformation from "./ItemInformation";
import ProductInformation from "./ProductInformation";
import Resource from "./Resource";
import Procurement from "./Procurement";
import { useSelector } from "react-redux";
import ActionDate from "./ActionDate";
import AssetMangement from "./AssetManagement";

const DemoTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 13
}));

const DemoTabs = styled(Tabs)(({ theme }) => ({
    minWidth: 200,
    [theme.breakpoints.down('xs')]: {
        marginLeft: '0%',
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '20px',
        fontSize: 10,
    },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
    minWidth: 110,
    fontSize: 14,
    fontFamily: 'open sans',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    [theme.breakpoints.down('xs')]: {
        minWidth: 8,
        fontSize: 10,
    },
    '&:hover': {
        backgroundColor: '#f6f7ff',
        color: 'black',
    },
}));


const ItemDetails = ({
    itemData,
    projectData,
    getInitialData
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [activeTab, setActiveTab] = useState(0);
    
    return (
        <Grid container spcaing={2}>
            <Grid item xs={12} sm={12} md={6} lg={3}>
                <Box display="flex" flexDirection="column">
                    <img
                        src={itemData?.product?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${itemData?.product?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                        style={{ width: 200, aspectRatio: 'auto', imageRendering: 'auto' }}
                        alt="big img"
                    />
                    <img
                        src={itemData?.product?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${itemData?.product?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                        style={{ width: 50, aspectRatio: 'auto', border: '1px solid black', marginTop: "5px" }}
                        alt="small img"
                    />
                </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={9}>
                <Box display="flex" justifyContent="space-between">
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>{itemData?.product_data?.model !== undefined ? itemData?.product_data?.model : itemData?.product?.model !== 'null' ? itemData?.product?.model !== null ? itemData?.product?.model : 'UnSpecified' : 'UnSpecified'}</Typography>
                    <Box>
                        <Typography variant="body1" style={{ fontWeight: 600, color: 'gray' }}>{itemData?.product_data?.price_type ? `${PriceType.find((a) => a.value === itemData?.product_data?.price_type)?.name} Price` : itemData?.product?.price_type ? `Product ${PriceType.find((a) => a.value === itemData?.product?.price_type)?.name} Price` : 'Price'}</Typography>
                        <Box display="flex" gap={1} alignItems="center">
                            {itemData?.unit_price !== itemData?.product?.list_price && (
                                <Tooltip title={`Kindly note that the current price does not match the catalog price, which is listed as ${`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(itemData?.product?.list_price) : 0}`}`}>
                                    <img src="/images/alert.png" alt="alert" width="15px" height="15px" style={{ marginBottom: '4px' }} />
                                </Tooltip>
                            )}
                            <Typography variant="body1" style={{ fontWeight: 'bold' }}>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(itemData?.unit_price) : 0}`}</Typography>
                        </Box>
                    </Box>
                </Box>
                <Divider />
                <Grid container spacing={1} mt={1}>
                    <Grid item sm={12} md={7}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Description:</DemoTypo>
                            <DemoTypography variant="body2">{`${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Category:</DemoTypo>
                            <DemoTypography variant="body2">{`${itemData?.product?.category?.name || ''}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Subcategory:</DemoTypo>
                            <DemoTypography variant="body2">{`${itemData?.product?.["sub_category"]?.name || ''}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Manufacturer:</DemoTypo>
                            <DemoTypography variant="body2">{`${handleUndefined(itemData?.manufacturer?.name, itemData?.product?.manufacturer?.name) || '--'}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Catalog #:</DemoTypo>
                            <DemoTypography variant="body2">{`${handleUndefined(itemData?.product_data?.catalog, itemData?.product?.catalog) !== "0" && handleUndefined(itemData?.product_data?.catalog, itemData?.product?.catalog) !== null ?  handleUndefined(itemData?.product_data?.catalog, itemData?.product?.catalog) : '--'}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Vendor :</DemoTypo>
                            <DemoTypography variant="body2">{`${handleUndefined(itemData?.product_data?.vendor?.name, itemData?.product?.vendor?.name) || '--'}`}</DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Alternate Description:</DemoTypo>
                            <DemoTypography variant="body2">{itemData?.alternate_description || `${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}` || '--'}</DemoTypography>
                        </Box>
                    </Grid>
                    <Grid item sm={12} md={5}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Numeric ID :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product?.is_customer_product ?
                                    `C-${itemData?.product?.alternate_id}`
                                    :
                                    itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` :
                                        `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(0).padStart(3, '0')}`
                                }
                            </DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Alphanumeric ID :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product?.is_customer_product ?
                                    `C-${itemData?.product?.alternate_id}`
                                    : itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["prefix"] || ''}${itemData?.product?.sub_category?.["prefix"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` :
                                        `${itemData?.product?.category?.["prefix"] || ''}${itemData?.product?.sub_category?.["prefix"] || ''}-${String(0).padStart(3, '0')}`
                                }
                            </DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Alt ID :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product?.alternate_id ? `C-${itemData?.product?.alternate_id}` : itemData?.product?.alternate_id ? `C-${itemData?.product?.alternate_id}` : '--'}
                            </DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Custom ID1 :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product_data?.custom_id_1 || '--'}
                            </DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Custom ID2 :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product_data?.custom_id_2 || '--'}
                            </DemoTypography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypo variant="body2">Govt. ID :</DemoTypo>
                            <DemoTypography variant="body2">
                                {itemData?.product_data?.govt_id ? itemData?.product_data?.govt_id : itemData?.product?.govt_id ? itemData?.product?.govt_id : '--'}
                            </DemoTypography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} mt={1}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <DemoTabs
                        value={activeTab}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <DemoTab label="Item Information" value={0} onClick={() => setActiveTab(0)} />
                        <DemoTab label="Product Information" value={1} onClick={() => setActiveTab(1)} />
                        {isUser?.code !== 'orgGuestUser' && (
                            <DemoTab label="Resources" value={2} onClick={() => setActiveTab(2)} />
                        )}
                        <DemoTab label="Procurement" value={3} onClick={() => setActiveTab(3)} />
                        <DemoTab label="Action Dates" value={4} onClick={() => setActiveTab(4)} />
                        <DemoTab label="Asset Management" value={5} onClick={() => setActiveTab(5)} />
                    </DemoTabs>
                </Box>
                {activeTab === 0 && (
                    <ItemInformation
                        itemData={itemData}
                    />
                )}
                {activeTab === 1 && (
                    <ProductInformation
                        itemData={itemData}
                        projectData={projectData}
                    />
                )}
                {(activeTab === 2 && isUser?.code !== 'orgGuestUser') && (
                    <Resource
                        itemData={itemData}
                        getInitialData={getInitialData}
                    />
                )}
                {activeTab === 3 && (
                    <Procurement
                        itemData={itemData}
                    />
                )}
                {activeTab === 4 && (
                    <ActionDate
                        itemData={itemData}
                        getInitialData={getInitialData}
                    />
                )}
                {activeTab === 5 && (
                    <AssetMangement
                        itemData={itemData}
                        getInitialData={getInitialData}
                        projectData={projectData}
                    />
                )}
            </Grid>
        </Grid>
    )
}

export default ItemDetails;